// src/pages/Rules.js
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";

const Rules = () => {
  const { t, setLanguageFromURL } = useTranslation();
  const { lang } = useParams();

  useEffect(() => {
    if (lang) {
      setLanguageFromURL(lang);
    }
  }, [lang, setLanguageFromURL]);

  return (
    <div className="rules-page" role="main" aria-labelledby="rules-title">
      {lang !== "ru" ? (
        <div className="container">
          <header className="page-header">
            <h1 id="rules-title">Bingo loto sünnipäevaloosi mängureeglid</h1>
          </header>

          <div
            className="rules-content"
            role="article"
            aria-labelledby="rules-title"
          >
            <section aria-labelledby="section1-heading">
              <ol>
                <li>
                  Bingo loto sünnipäevaloosi (edaspidi: lisaloos) korraldajaks
                  on Eesti Loto AS (edaspidi: Eesti Loto), asukoht Hallivanamehe
                  4, 11317 Tallinn, registrikood 10281170, telefon 650 2030.
                </li>
                <li>
                  Lisaloos viiakse läbi vastavalt käesolevatele mängureeglitele.
                  Lisaloosi võidu vastuvõtmisega kinnitab mängija lisaloosi
                  mängureeglitega nõustumist.
                </li>
                <li>
                  Lisaloosis osalevad automaatselt (s.t ilma täiendava
                  registreerimiseta) ajavahemikus 01.02.-28.02.2026 ostetud
                  vähemalt kahe mängukombinatsiooniga (ehk väljaga) Bingo loto
                  piletid.
                  <ul>
                    <li>
                      Iga mängukombinatsioon piletil annab lisaloosi loosimisel
                      ühe hääle. Näiteks kahe mängukombinatsiooniga pilet annab
                      loosimisel kaks häält, kolme mängukombinatsiooniga pilet
                      kolm häält jne.
                    </li>
                    <li>
                      Kui pilet on ostetud mitmeks järjestikuseks Bingo loto
                      loosimiseks, saab lisaloosis osalevate häälte arvu, kui
                      korrutada pileti mängukombinatsioonide arv loosimiste
                      arvuga. Näiteks viieks Bingo loto loosimiseks ostetud
                      nelja mängukombinatsiooniga pilet osaleb lisaloosi
                      loosimisel 20 häälega.
                    </li>
                  </ul>
                </li>
                <li>
                  Lisaloosi loosimine toimub 02.03.2026. Loosimine viiakse läbi
                  Eesti Lotos, kasutades elektroonilist juhuarvu generaatorit
                  ehk RNG-d (Random Number Generator).{" "}
                </li>
                <li>
                  Loositakse välja 30 võitjat, kes saavad igaüks võiduks 1 000
                  eurot.
                </li>
                <li>
                  Lisaloosi tulemused avaldatakse hiljemalt 03.03.2026 Eesti
                  Loto kodulehel www.eestiloto.ee.{" "}
                </li>
                <li>
                  Võitjatega võtab Eesti Loto ühendust kolme tööpäeva jooksul
                  pärast loosimist, kasutades Eesti Loto infosüsteemis või
                  rahvastikuregistris mängija isikukoodile vastavaid
                  kontaktandmeid.
                </li>
                <li>
                  Lisaloosi võidu kättesaamiseks tuleb esitada võiduavaldus,
                  mida saab vormistada:
                  <br />
                  Eesti Lotos/Eesti Posti postkontorites isikut tõendava
                  dokumendi alusel või digiallkirjastatult e-posti teel.
                  Võiduavaldus koos vormistamise juhistega asub Eesti Loto
                  kodulehel: Võiduavaldus kuni 1999 eurot.{" "}
                </li>
                <li>Lisaloosi võitude vormistamise tähtaeg on 13.04.2026.</li>
                <li>
                  Mängija vastutab Eesti Loto kodulehel ja/või
                  rahvastikuregistris registreeritud isikuandmete õigsuse ning
                  korrektsuse eest. Valede või ebakorrektsete andmete esitamisel
                  ei taga Eesti Loto võidust teavitamist ega võidu
                  väljamaksmist. Õigeaegselt vormistamata võidud ei kuulu
                  väljamaksmisele ja arvatakse Eesti Loto reservfondi.{" "}
                </li>
                <li>
                  Lisaloosis osalemise ja võitude kättesaamisega seotud kulutusi
                  Eesti Loto mängijatele ei kompenseeri.
                </li>
                <li>Lisaloosis ei saa osaleda alla 18-aastased isikud.</li>
                <li>
                  Lisaloosis osalemisest on välistatud Eesti Loto töötajad (v.a
                  lapsehoolduspuhkusel olevad isikud) ja Eesti Loto nõukogu
                  liikmed.
                </li>
                <li>
                  Vääramatu jõu ilmnemisel on Eesti Lotol ühepoolne õigus
                  katkestada lisaloos ja jätta võidud välja loosimata ja/või üle
                  andmata, teavitades sellest esimesel võimalusel meedia
                  vahendusel.
                </li>
                <li>
                  Isikuandmete töötlemine toimub vastavalt Eesti Loto kodulehel
                  avaldatud tingimustele: Isikuandmete töötlemise põhimõtted.
                </li>
                <li>
                  Lisaloosiga seotud pretensioonid tuleb saata kirjalikult Eesti
                  Loto aadressile Hallivanamehe 4, 11317 Tallinn või e-posti
                  aadressile klienditugi@eestiloto.ee 15 päeva jooksul pärast
                  loosimist. Pretensiooni lahendamise tähtaeg on 2 nädalat
                  arvates pretensiooni laekumisest. Anonüümseid pretensioone ja
                  avaldusi läbi ei vaadata ning neile ei vastata.{" "}
                </li>
              </ol>
            </section>
          </div>
        </div>
      ) : (
        <div className="container">
          <header className="page-header">
            <h1 id="rules-title">
              Правила дополнительного розыгрыша «День рождения Bingo loto»
            </h1>
          </header>

          <div
            className="rules-content"
            role="article"
            aria-labelledby="rules-title"
          >
            <section aria-labelledby="section1-heading">
              <ol>
                <li>
                  Учредителем дополнительного розыгрыша „День рождения Bingo
                  Loto“ (далее – дополнительный розыгрыш) является AS Eesti Loto
                  (далее - Eesti Loto), адрес: Халливанамехе 4, 11317 Таллинн,
                  регистрационный код 10281170, телефон 650 2030;{" "}
                </li>
                <li>
                  Дополнительный розыгрыш проводится в соответствии с настоящими
                  правилами. Получением выигрыша игрок подтверждает своё
                  согласие с правилами дополнительного розыгрыша.
                </li>
                <li>
                  В дополнительном розыгрыше автоматически (т.е. без
                  дополнительной регистрации) участвуют билеты Bingo loto,
                  купленные в период 01.02–28.02.2026 и содержащие минимум две
                  игровые комбинации (поля).
                  <ul>
                    <li>
                      Каждая игровая комбинация на билете даёт один голос в
                      дополнительном розыгрыше. Например, билет с двумя
                      комбинациями даёт два голоса, с тремя — три голоса и так
                      далее.
                    </li>
                    <li>
                      Если билет куплен на несколько последовательных розыгрышей
                      Bingo loto, то количество голосов определяется умножением
                      числа игровых комбинаций на количество розыгрышей.
                      Например, билет с четырьмя игровыми комбинациями,
                      купленный на пять розыгрышей, участвует в дополнительном
                      розыгрыше с 20 голосами.
                    </li>
                  </ul>
                </li>
                <li>
                  Дополнительный розыгрыш состоится 02.03.2026 в Eesti Loto.
                  Выигрыши дополнительного розыгрыша разыгрываются с помощью
                  генератора случайных чисел RNG (random number generator).{" "}
                </li>
                <li>
                  Разыгрываются 30 победителей, выигрыш каждого составляет 1000
                  евро.
                </li>
                <li>
                  Результаты дополнительного розыгрыша будут опубликованы не
                  позднее 03.03.2026 на сайте www.eestiloto.ee.
                </li>
                <li>
                  Представитель Eesti Loto свяжется со всеми победителями в
                  течение пяти рабочих дней после розыгрыша, используя
                  контактные данные игрока из инфосистемы Eesti Loto или из
                  регистра народонаселения в соответствии с личным кодом игрока.
                </li>
                <li>
                  Для получения выигрыша необходимо подать заявление о выплате
                  выигрыша, которое можно оформить в офисе Eesti Loto/отделениях
                  Eesti Post при предъявлении документа, удостоверяющего
                  личность, либо отправить по электронной почте с цифровой
                  подписью в Eesti Loto. Форму заявления и инструкцию по ее
                  заполнению можно найти на сайте Eesti Loto: Заявление о
                  выплате выигрыша до 1999 евро.{" "}
                </li>
                <li>
                  Срок оформления выигрышей дополнительного розыгрыша — до
                  13.04.2026.
                </li>
                <li>
                  Игроки берут на себя ответственность за правильность и
                  корректность личных данных, зарегистрированных на сайте Eesti
                  Loto и/или в регистре народонаселения. При предоставлении
                  игроком ложных или некорректных данных Eesti Loto не
                  обеспечивает игрока информацией о выигрыше и самим выигрышем.
                  Выигрыши, не оформленные вовремя, не подлежат выплате и
                  перечисляются в резервный фонд Eesti Loto.
                </li>
                <li>
                  Затраты, связанные с участием в розыгрышах и получением
                  выигрыша, игрокам не компенсируются.{" "}
                </li>
                <li>
                  В дополнительном розыгрыше не могут участвовать лица моложе 18
                  лет.
                </li>
                <li>
                  Работники Eesti Loto (кроме находящихся в отпуске по уходу за
                  ребёнком) и члены совета Eesti Loto не могут участвовать в
                  дополнительном розыгрыше.{" "}
                </li>
                <li>
                  В случае непреодолимых обстоятельств (force majeure) Eesti
                  Loto вправе в одностороннем порядке прервать дополнительный
                  розыгрыш и не разыгрывать и/или не выдавать выигрыши, сообщив
                  об этом через СМИ при первой возможности.
                </li>
                <li>
                  Обработка персональных данных осуществляется в соответствии с
                  условиями, опубликованными на сайте Eesti Loto: Принципы
                  обработки персональных данных.
                </li>
                <li>
                  Претензии, связанные с дополнительным розыгрышем, необходимо
                  направить в письменном виде по адресу Eesti Loto:
                  Халливанамехе 4, 11317 Таллинн или на электронную почту
                  klienditugi@eestiloto.ee в течение 15 дней после розыгрыша.
                  Срок рассмотрения претензии — 2 недели с момента её получения.
                  Анонимные претензии и заявления не рассматриваются и на них не
                  отвечают.
                </li>
              </ol>
            </section>
          </div>
        </div>
      )}
    </div>
  );
};

export default Rules;
